import { render, staticRenderFns } from "./Comp46t2.vue?vue&type=template&id=5b47ec28&scoped=true&"
import script from "./Comp46t2.vue?vue&type=script&lang=js&"
export * from "./Comp46t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp46t2.vue?vue&type=style&index=0&id=5b47ec28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47ec28",
  null
  
)

export default component.exports